exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".silenced-user:hover {\r\n    color: #000;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/silenced-user/silenced-user.component.css
// module id = ../../../../../src/app/profile-update/silenced-user/silenced-user.component.css
// module chunks = main